<template>
    <div>
        <avue-crud
                :option="option"
                :data="data"
                :page="page"
                @refresh-change="refreshChange"
                @search-change="searchChange"
                @row-save="store"
                @row-update="update"
                @row-del="del"
                @size-change="sizeChange"
                @current-change="currentChange"
                :upload-before="uploadBefore"
                ref="crud"
        >
        </avue-crud>
    </div>
</template>
<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    data() {
      return {
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText: '新增员工', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '工号',
              prop: 'id',
              span: 24,
              search: true,
              rules: [{
                required: true, message: '工号不能为空', trigger: 'blur'
              }]
            },
            {
              label: '用户名',
              prop: 'username',
              span: 24,
              search: true,
              rules: [{
                type: 'string', required: true, message: '用户名不能为空', trigger: 'blur'
              }]
            },
            {
              label: '手机号',
              prop: 'tel',
              span: 24,
              search: true,
              rules: [{
                required: true, message: '手机号不能为空', trigger: 'blur'
              }]
            },
            {
              label: '身份证号',
              prop: 'id_num',
              span: 24,
              rules: [{
                required: true, message: '身份证号不能为空', trigger: 'blur'
              }]
            },
            {
              label: '在职状态',
              prop: 'status',
              span: 24,
              addDisplay: false,
              type: 'select',
              dicData: [{'label': '在职', 'value': 1}, {'label': '离职', 'value': 2}]
            },
            {
              label: 'TEAM',
              overHidden: true,
              prop: 'team',
              span: 24
            },
            {
              label: 'Group',
              overHidden: true,
              prop: 'group_name',
              span: 24
            }
          ]
        }
      }
    }
  }
</script>
